import templateStr from 'text!./PaQuickQuoteAddressInputState.html';
import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './PaQuickQuoteAddressInputState-hashed.scss';

export default ['LocaleService', function (LocaleService) {

    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(templateStr, styles),
        scope: {
            address: '=',
            readonly: '@',
            defaultCountryCode: '@'
        },

        link: function link(scope) {
            var defaultCountryCode = scope.defaultCountryCode || LocaleService.getCountry().code;

            scope.shouldShow = function (value) {
                return angular.isDefined(value.value);
            };

            function syncAddressData() {
                if (scope.address.value) {
                    scope.address.country.value = scope.address.country.value || defaultCountryCode;
                } else {
                    scope.address.value = {
                        country: defaultCountryCode
                    };
                }
            }

            scope.$watch('address.value', syncAddressData);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/quickquote/pa/directives/Address/PaQuickQuoteAddressInputState.js
// module id = 2186
// module chunks = 0